import { getIndexFromProps } from '../../../../selectors/_propsGetters_';
import { StateType } from '../../../../states';
import { GRAssetsBySkinId } from '../../constants/assets';
import { selectGRGlobalSkinId } from '../../selectors/global/globalPrimary.selector';
import { selectGRMiscCurrentNotification } from '../../selectors/misc/miscPrimary.selector';
import { selectGRBetsFromRound } from '../../selectors/round.selector';
import { GRRound } from '../../types/round';

type GRChipSelectorProps = { index: number; roundId: GRRound };

const selectGRBet = (state: StateType, props: GRChipSelectorProps) => {
  const bets = selectGRBetsFromRound(state, props);
  const index = getIndexFromProps(state, props);

  if (index === undefined) {
    return null;
  }

  return bets[index] ?? { counted: false };
};

const selectGRBetStatus = (state: StateType, props: GRChipSelectorProps) => {
  const bet = selectGRBet(state, props);
  return bet?.status;
};

const selectGRBetCounted = (state: StateType, props: GRChipSelectorProps) => {
  const bet = selectGRBet(state, props);
  return bet?.counted ?? false;
};

const selectGRBetBetslipReference = (state: StateType, props: GRChipSelectorProps) => {
  const bet = selectGRBet(state, props);
  return bet?.betslipReference;
};

const selectGRChipShouldAnimate = (state: StateType, props: GRChipSelectorProps) => {
  const betslipReference = selectGRBetBetslipReference(state, props);
  const currentNotif = selectGRMiscCurrentNotification(state);

  return !!betslipReference && betslipReference === currentNotif?.data?.betslipReference;
};

const selectGRChipImage = (state: StateType, props: GRChipSelectorProps) => {
  const skinId = selectGRGlobalSkinId(state);
  const status = selectGRBetStatus(state, props);

  if (!skinId) {
    return null;
  }

  if (!GRAssetsBySkinId[skinId]?.Chips) {
    return null;
  }

  return status ? GRAssetsBySkinId[skinId].Chips?.[status] : GRAssetsBySkinId[skinId].Chips?.DEFAULT;
};

const selectGRChipAnimation = (state: StateType, props: GRChipSelectorProps) => {
  const skinId = selectGRGlobalSkinId(state);
  const status = selectGRBetStatus(state, props);

  if (!skinId) {
    return null;
  }

  if (!GRAssetsBySkinId[skinId]?.ChipAnimations) {
    return null;
  }

  return status ? GRAssetsBySkinId[skinId].ChipAnimations?.[status] : GRAssetsBySkinId[skinId].ChipAnimations?.PENDING;
};

const selectGRChipProps = (state: StateType, props: GRChipSelectorProps) => {
  const shouldAnimate = selectGRChipShouldAnimate(state, props);

  return {
    index: getIndexFromProps(state, props),
    status: selectGRBetStatus(state, props),
    counted: selectGRBetCounted(state, props),
    betslipReference: selectGRBetBetslipReference(state, props),
    shouldAnimate: shouldAnimate,
    statusAnimation: shouldAnimate ? selectGRChipAnimation(state, props) : null,
    ChipImage: selectGRChipImage(state, props),
  };
};

export default selectGRChipProps;
